import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LabelIcon from '@mui/icons-material/Label';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Popup1099DA from '@/components/ui/1099PopupDA';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExtensionToInformationReturns from '@/components/ui/ExtensionToIR';
import PricingDetailsComp from '@/components/ui/PricingDetailsComp';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099A = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `<span style="color:#c1121f;font-size:18px; font-weight: 700;">Last Chance!</span> <span style="font-size:18px;">Form 1099 deadline is TODAY-</span><span style="color:#000; font-size:18px; font-weight: 600;">January 31, 2025</span><span style="font-size:18px;">! </span>`,
  //   SubHeading: 'File before it&apos;s too late!',
  //   CtaText: 'Submit Now',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099b`,
  //   isActive: true,
  // };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1099-DA Online for 2025 | TaxZerone"
          description="File IRS Form 1099-DA securely online with TaxZerone. Bulk upload supported, IRS-authorized e-filing, instant delivery, and the best pricing in the industry."
          keywords=""
          canonical="information-returns/efile-irs-form-1099-da/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Popup1099DA />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background:
              'linear-gradient(92deg,rgba(51, 92, 103, 1) 0%, rgba(158, 42, 43, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'left', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.22rem' },
                color: '#ccc',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 Deadline Has Passed! </strong> E-File Your 2025{' '}
              <b style={{ fontWeight: 600, color: '#f7ede2' }}>Form 1099-DA</b>{' '}
              Today to Stay IRS-Compliant and Avoid Penalties.
            </Typography>

            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Form 1099-DA
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1099-DA</span>
                </span>{' '}
                Online for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Report digital asset proceeds with IRS-authorized e-filing
                through TaxZerone. We make Form 1099-DA filing simple, whether
                you’re filing just one form or thousands.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                    // href="/contact-us/"
                  >
                    E-file Form{' '}
                    <Box
                      component="span"
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      1099-DA
                    </Box>
                    &nbsp;Now
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099da-landing-img.webp" />
                <source srcSet="/assets/images/1099da-landing-img.png" />
                <img
                  src="/assets/images/1099da-landing-img.png"
                  alt="File IRS Form 1099-DA Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099da-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099da-landing-img-sm.png" />
                <img
                  src="/assets/images/1099da-landing-img-sm.png"
                  alt="File IRS Form 1099-DA Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Start at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with prices as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form for bulk filings.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 180, md: 200 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/1099da-img.webp" />
                  <source srcSet="/assets/images/1099da-img.png" />
                  <img
                    src="/assets/images/1099da-img.png"
                    alt="What is IRS Form 1099-DA? "
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ mr: 0 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                What is IRS Form 1099-DA?
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Form <b>1099-DA (Digital Asset Proceeds)</b> is the IRS
                information return used to report proceeds from digital-asset
                transactions (cryptocurrency, NFTs, qualifying stablecoins,
                tokenized assets, and similar digital representations of value)
                that brokers effect for customers. The form is intended to bring
                digital-asset reporting in line with other broker reporting
                regimes.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                This form helps ensure taxpayers accurately report their digital
                asset gains and losses.
              </Typography>
              <Typography variant="body1">
                Typically, Form 1099-DA is issued when:
              </Typography>
              <List
                sx={{
                  display: 'inline-block',
                  mb: 5,
                  ml: 2,
                }}
              >
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    A customer sells or exchanges cryptocurrency on a brokered
                    platform.
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    NFTs or tokens are traded or redeemed on a covered platform.
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    Stablecoins are converted (as defined under the
                    instructions) in reportable transactions.
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Any brokered transaction involving digital assets occurs.
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  py: { xs: 2, sm: 4, md: 4 },
                  px: { xs: 2, sm: 4, md: 6 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 800,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 4,
                    textAlign: 'center',
                  }}
                >
                  Any brokered transaction involving digital assets occurs.
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  To complete your filing with TaxZerone, gather the following:
                </Typography>
                <Box
                  sx={{
                    justifyContent: 'center',
                    maxWidth: 650,
                    mx: 'auto',
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Filer Information:</b> Name, EIN, and Address
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Recipient Information:</b> Name, TIN, and Address
                        (TIN matching recommended).
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Transaction Details: </b> Type of digital asset,
                        date acquired (if available), date disposed,
                        quantity/units, transaction identifier(s) where
                        applicable.
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b>
                          Financial details (2025 reporting): Gross
                          proceeds{' '}
                        </b>{' '}
                        from the sale/exchange are required for 2025
                        transactions. Cost basis and gain/loss information are
                        not required for sales effected in 2025 (brokers may
                        voluntarily report basis for 2025, but are not required
                        to). Mandatory basis/gain reporting and related boxes
                        apply more broadly for 2026 and later as described in
                        IRS guidance.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                  You can also upload your filings in{' '}
                  <span style={{ fontWeight: 600 }}>
                    bulk using our pre-formatted Excel templates.
                  </span>
                </Typography>
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 0,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                  >
                    File 1099-DA Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                Who Must File Form 1099-DA?
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                You are required to file Form 1099-DA if you are a:
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                  ml: 2,
                }}
              >
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    Digital asset broker or exchange{' '}
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText> Hosted wallet provider </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Payment processor facilitating crypto payments
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 2, mt: -2 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Platform that enables trading or redemption of NFTs,
                    <br />
                    tokens, or stablecoins
                  </ListItemText>
                </ListItem>
              </List>
              <Alert severity="warning" icon={false} sx={{ mb: 4 }}>
                <b> Note:</b> Only brokers and intermediaries are required to
                file. Individual taxpayers do not file 1099-DA; they receive it
                to help report gains or losses on their personal tax returns.
              </Alert>
              {/* <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                
                >
                  Stay Tuned for E-filing
                </Button>
              </Box> */}
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/who-file-1099da-img.webp" />
                  <source srcSet="/assets/images/who-file-1099da-img.png" />
                  <img
                    src="/assets/images/who-file-1099da-img.png"
                    alt="Who Must File Form 1099-DA?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                3 Simple Steps to Complete Your Form 1099-DA E-filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1099-DA with TaxZerone is fast, easy, and
                secure.
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Here’s how you can do it in just three simple steps:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1099-da-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1099-da-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1099-da-steps-img.png"
                  alt="3 Simple Steps to Complete Your Form 1099-DA E-filing"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Information:"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Information:
                    </Typography>
                    <Typography variant="body1">
                      Log in to TaxZerone, choose Form 1099-DA, and fill in
                      broker, recipient, and transaction details using our
                      guided interface.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt=" Review & Submit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Submit:
                    </Typography>
                    <Typography variant="body1">
                      Our platform validates your form for IRS compliance,
                      helping prevent errors or rejections. Once reviewed,
                      <br />
                      e-file it directly with the IRS.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt=" Share Borrower Copies:"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Share Borrower Copies:
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      After filing, send copies to customers via:{' '}
                    </Typography>
                    <ol type="a">
                      <li style={{ marginBottom: 6 }}>
                        <span style={{ fontWeight: 600 }}>ZeroneVault:</span>{' '}
                        Encrypted digital delivery
                      </li>
                      <li style={{ marginBottom: 6 }}>
                        <span style={{ fontWeight: 600 }}>Postal Mail:</span>{' '}
                        Printed and mailed copies
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>Download:</span>{' '}
                        Secure PDF download from your account
                      </li>
                    </ol>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                  // href="/contact-us/"
                >
                  E-file Form 1099-DA
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1099-DA E-filing?
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for businesses of all
                sizes. Here’s why:
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="Built-in IRS Checks"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Built-in IRS Checks
                </Typography>
                <Typography variant="body1">
                  Our system automatically validates your Form 1099-DA entries
                  before submission, helping prevent rejections and penalties by
                  catching missing or incorrect details.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Share Recipient Copies "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Share Recipient Copies
                </Typography>
                <Typography variant="body1">
                  Once filed, quickly send recipient copies digitally via
                  ZeroneVault or opt for postal delivery-no manual mailing
                  required.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Fast Bulk Filing Option"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Fast Bulk Filing Option
                </Typography>
                <Typography variant="body1">
                  Need to file dozens or hundreds of 1099-DA forms? Easily
                  upload multiple records in one go and streamline your entire
                  reporting process.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Best Price in the Industry"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Best Price in the Industry
                </Typography>
                <Typography variant="body1">
                  Enjoy affordable rates based on your filing volume. With
                  TaxZerone, you save both time and money-without compromising
                  on accuracy.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Step-by-Step Filing Interface"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Step-by-Step Filing Interface
                </Typography>
                <Typography variant="body1">
                  Our intuitive form-filing tool walks you through each step no
                  technical skills or tax expertise needed.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing
                </Typography>
                <Typography variant="body1">
                  Access smart prompts and <br />
                  expert-guided help during filing to ensure you get it right
                  the first time.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 15,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Form 1099-DA Filing Deadlines – 2025 Tax Year
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            mb={0}
            py={{ xs: 0, sm: 4, md: 5 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/recipient-copies-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/recipient-copies-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/recipient-copies-icon.png"
                      alt="Provide borrower copy "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Provide recipient copy
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: { md: 20, sm: 18, xs: 17 } }}
                >
                  <b> Due Date:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 17, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with  IRS (e-file)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with IRS (e-file)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: { md: 20, sm: 18, xs: 17 } }}
                >
                  <b> Due Date:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 31, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-file-icon.png"
                      alt="File with the IRS (paper)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (paper)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: { md: 20, sm: 18, xs: 17 } }}
                >
                  <b> Due Date:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 2, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                m: 'auto',
                display: 'flex',
              }}
            >
              <Box sx={{ maxWidth: 600 }}>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mt: 1, mb: 0, textAlign: 'left' }}
                >
                  <b>Note:</b> Deadlines may shift if they fall on weekends or
                  holidays.
                </Alert>
              </Box>
            </Grid>
            <Grid size={12} sx={{}}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
                >
                  E-file 1099-DA Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box component="section" sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <ExtensionToInformationReturns
          formName="form 1099 da"
          formRef="form1099da"
        />
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 3 }}>
                Late, incorrect, or missing filings for information returns
                (including 1099-DA) can lead to the following{' '}
                <Link
                  href="https://www.irs.gov/payments/information-return-penalties"
                  sx={{ color: '#2020ff' }}
                >
                  penalties
                </Link>{' '}
                <br />
                per form (for tax year <b>2025</b> reports due in 2026):
              </Typography>

              <Box component="div" sx={{ mb: 3, backgroundColor: '#fff' }}>
                <TableContainer>
                  <Table aria-label="Penalty Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                          }}
                        >
                          When filing is late or incorrect
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Penalty per form
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #b2b2b2a6' }}>
                          Within 30 days of due date
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          $60
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ borderBottom: '1px solid #b2b2b2a6' }}>
                          More than 30 days but by August 1
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          $130
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #b2b2b2a6' }}>
                          After August 1, or not filed at all
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          $340
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ borderBottom: '1px solid #b2b2b2a6' }}>
                          If filer intentionally disregards filing requirements
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          $680
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              <Typography variant="body1" sx={{ textAlign: 'center', mt: 2 }}>
                Penalties are adjusted annually for inflation and subject to
                maximums depending on business size.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <PricingDetailsComp formName="Form 1099-DA" colorCode="#4269e2" />
          <Box>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Need to send recipient copies by mail? Add postal delivery at just{' '}
              <span style={{ fontWeight: 600 }}> $1.75 per</span> form or
              electronic delivery via{' '}
              <Link
                href="https://taxzerone.zeronevault.com/"
                sx={{ color: '#2020ff' }}
              >
                ZeroneVault
              </Link>{' '}
              at <span style={{ fontWeight: 600 }}>$0.50</span>.{' '}
            </Typography>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ md: 6, xs: 12 }} sx={{}}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#faedcd',
                  p: 3,
                  pt: 2,
                  pb: 2,
                  minHeight: '100%',
                  borderRadius: 3,
                }}
              >
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ alignItems: 'center' }}
                >
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 2,
                        textAlign: 'left',
                      }}
                    >
                      Common Use Cases
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ mb: 0, ml: -2, '& li': { mb: 1.1 } }}
                    >
                      <li> Reporting crypto-to-fiat sales </li>
                      <li> Recording NFT trades or redemptions </li>
                      <li> Reporting stablecoin conversions </li>
                      <li>
                        Digital asset brokers reporting customer exchanges
                      </li>
                    </Box>
                  </Box>
                  <Box component="picture" sx={{}}>
                    <source
                      srcSet="/assets/images/1099da-use-case-img.webp"
                      width={288}
                      height={266}
                    />
                    <source
                      srcSet="/assets/images/1099da-use-case-img.png"
                      width={288}
                      height={266}
                    />
                    <img
                      src="/assets/images/1099da-use-case-img.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      width={288}
                      height={266}
                      className="img-responsive"
                    />
                  </Box>
                </Stack>
                <Typography variant="body1" sx={{ mb: 6 }}>
                  Want to know if your situation requires a 1099-DA?{' '}
                  <Link
                    href="https://www.taxzerone.com/contact-us/"
                    sx={{ color: '#2020ff' }}
                  >
                    Contact our support team
                  </Link>{' '}
                  -we’ll help you determine eligibility.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: 'left' }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#caf0f8',
                  p: 3,
                  pt: { lg: 5, md: 6, sm: 0 },
                  pb: { lg: 5, md: 6, sm: 0 },
                  borderRadius: 3,
                  minHeight: '100%',
                }}
              >
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ alignItems: 'center' }}
                >
                  <Box>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                        fontWeight: 600,
                        mb: 2,
                        textAlign: 'left',
                      }}
                    >
                      Pro Tip
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                      Schedule Your 1099-DA Filing Early
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Use our filing scheduler to select a future date for
                      submission. This allows:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.1 } }}>
                      <li> Recipient review in advance </li>
                      <li> Early error detection </li>
                      <li> On-time delivery before deadlines </li>
                    </Box>
                  </Box>
                  <Box component="picture" sx={{}}>
                    <source
                      srcSet="/assets/images/1099da-pro-tips-img.webp"
                      width={288}
                      height={266}
                    />
                    <source
                      srcSet="/assets/images/1099da-pro-tips-img.png"
                      width={288}
                      height={266}
                    />
                    <img
                      src="/assets/images/1099da-pro-tips-img.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      width={288}
                      height={266}
                      className="img-responsive"
                    />
                  </Box>
                </Stack>
                <Typography variant="body1">
                  TaxZerone offers the perfect balance of compliance,
                  convenience, and cost. Don’t settle for outdated or overpriced
                  alternatives.
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          <Box sx={{ mt: 5, textAlign: 'center' }}>
            <Button
              variant="contained"
              sx={{
                mt: 0,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
            >
              Start Your 1099-DA Filing
            </Button>
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Why Not File Form 1099-DA Manually?
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Filing on paper may seem simple—but it can cost you more time
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                and money in the long run due to delays and manual errors.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={2}
            // py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/mannual-file-img.webp" />
                  <source srcSet="/assets/images/mannual-file-img.png" />
                  <img
                    src="/assets/images/mannual-file-img.png"
                    alt="Common Drawbacks of Manual Filing:"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'left',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '20px !important',
                    fontWeight: 600,
                    textAlign: 'left',
                    mt: 3,
                  }}
                >
                  Common Drawbacks of Manual Filing:{' '}
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Time-consuming:</span>{' '}
                    Requires printing, addressing envelopes, and visiting the
                    post office
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Higher error risk:</span>{' '}
                    No validations, leading to IRS rejections
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> No tracking:</span> You
                    won’t know if the IRS or recipient received the form
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Delayed processing:
                    </span>{' '}
                    Paper forms take longer to process than electronic
                    submissions{' '}
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      No audit protection:
                    </span>{' '}
                    Manual errors may result in penalties or correction
                    forms{' '}
                  </li>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                }}
              >
                Benefits of E-filing with TaxZerone:
              </Typography>

              <List
                sx={{
                  display: 'inline-block',
                  mb: 2,
                }}
              >
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Instantly submit forms to the IRS{' '}
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Auto-checks for TIN mismatches and missing fields{' '}
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Schedule filing dates to stay ahead of deadlines
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Recipient copies sent via ZeroneVault or mail
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemIcon sx={{ minWidth: 'inherit', mr: 1, mt: 0 }}>
                    <CheckCircleIcon sx={{ color: '#1da94a' }} />
                  </ListItemIcon>
                  <ListItemText>
                    Access to support if you need help at any step
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/1099a-benefits-img.webp" />
                  <source srcSet="/assets/images/1099a-benefits-img.png" />
                  <img
                    src="/assets/images/1099a-benefits-img.png"
                    alt="Benefits of E-filing with TaxZerone:"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to E-file IRS Form 1099-DA?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 0,
            lineHeight: 1.5,
          }}
        >
          Avoid delays, rejections, and penalties-e-file your Form 1099-DA
          securely with TaxZerone in just minutes.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099da`}
          >
            File 1099-DA Now
          </Button>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="f1099-da-faq"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              id="f1099-da-faq"
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            {/* Question 1 */}
            <Box
              component="div"
              sx={{ mb: 3 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What’s the difference between Form 1099-DA and Form 1099-B?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      <Link
                        href="/resources/information-returns/form-1099-da-instructions/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1099-DA
                      </Link>{' '}
                      is used exclusively for digital asset transactions, while{' '}
                      <Link
                        href="/resources/information-returns/form-1099-b-instructions/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1099-B
                      </Link>{' '}
                      reports securities and commodities sales.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* Question 2 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the purpose of the 1099-DA form and who needs to file
                  it?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1.5 }}>
                      <Link
                        href="/resources/information-returns/form-1099-da-instructions/"
                        sx={{ color: '#2020ff', fontWeight: 600 }}
                      >
                        Form 1099-DA
                      </Link>
                      ,{' '}
                      <strong style={{ fontWeight: 600 }}>
                        Digital Asset Proceeds From Broker Transactions
                      </strong>
                      , is used to report proceeds from digital asset
                      transactions. Similar to Form 1099-B for traditional
                      investments, it helps standardize reporting of digital
                      asset sales, exchanges, and other reportable transactions.
                    </Typography>

                    <Typography variant="body1">
                      <strong style={{ fontWeight: 600 }}>
                        Purpose of Form 1099-DA:
                      </strong>
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1 } }}>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Standardizes Reporting:
                        </strong>{' '}
                        Provides consistent reporting of gross proceeds and,
                        when applicable, cost basis for digital asset
                        transactions.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Supports Tax Compliance:
                        </strong>{' '}
                        Gives the IRS transaction information reported by
                        brokers to help taxpayers accurately report digital
                        asset activity.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          Provides Transaction Details:
                        </strong>{' '}
                        Offers more specific transaction information than the
                        aggregate payment reporting previously associated with
                        Form 1099-K.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Question 3 */}
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  When is the deadline to submit the 1099-DA form?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1.5 }}>
                      For{' '}
                      <strong style={{ fontWeight: 600 }}>
                        IRS Form 1099-DA
                      </strong>{' '}
                      (Digital Asset Proceeds From Broker Transactions), the
                      deadlines depend on whether you are a broker furnishing
                      the form to a recipient/taxpayer or filing it directly
                      with the IRS.
                    </Typography>

                    <Typography variant="body1">
                      The standard deadlines for information returns (aligned
                      with rules for forms like 1099-B) are:
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1 } }}>
                      <li>
                        Furnishing statements to recipients/taxpayers:{' '}
                        <strong style={{ fontWeight: 600 }}>February 17</strong>{' '}
                        (of the year following the tax year—for instance)
                      </li>
                      <li>
                        Electronic filing (e-file) with the IRS:{' '}
                        <strong style={{ fontWeight: 600 }}>March 31</strong> of
                        the year following the tax year.
                      </li>
                      <li>
                        Paper filing with the IRS (if applicable/permitted):{' '}
                        <strong style={{ fontWeight: 600 }}>February 28</strong>{' '}
                        of the year following the tax year.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1099A;
